<div class="navigation-group" [class.collapsed]="collapsed">
  <div class="navigation-title navigation-group-title" *ngIf="title && !collapsed" [ngStyle]="{'color': color}">
    • {{ title }}
  </div>
  <nav class="navigation-links" [attr.aria-label]="title || 'Navigation menu'">
    <div *ngFor="let link of links" class="navigation-link-container">
      <a [routerLink]="link.route" routerLinkActive="active" class="navigation-link"
        (click)="link.action?.(); onLinkClick()" [attr.title]="collapsed ? link.label : null"
        [class.disabled]="link.enabled === false">
        <lucide-angular *ngIf="link.icon" [img]="icons[link.icon]" size="18" [attr.aria-label]="link.label"
          role="img"></lucide-angular>
        <span class="link-label navigation-link-text" [class.hidden]="collapsed">{{ link.label }}</span>
        <span class="link-tooltip" *ngIf="link.tooltip">{{ link.tooltip }}</span>
      </a>
    </div>
  </nav>
</div>